import type { Site, Languages } from '../types/common';

export const SEARCH_URLS: Record<Site, string> = {
  us: 'https://www.archdaily.com/search/all?q=',
  cl: 'https://www.archdaily.cl/search/all?q=',
  mx: 'https://www.archdaily.mx/search/all?q=',
  co: 'https://www.archdaily.co/search/all?q=',
  pe: 'https://www.archdaily.pe/search/all?q=',
  br: 'https://www.archdaily.com.br/search/all?q=',
  cn: 'https://www.archdaily.cn/search/all?q=',
}

export const SITE_TO_LANG: Record<Site, Languages> = {
  us: 'en',
  cl: 'es',
  mx: 'es',
  co: 'es',
  pe: 'es',
  br: 'pt',
  cn: 'zn',
}

export const MIN_INTERESTS: number = 3;
export const MAX_INTERESTS: number = 20;

export const TERMS_URLS: string = 'https://www.daaily.com/terms-conditions.html'

export const PRIVACY_URLS: string = 'https://www.daaily.com/privacy-policy.html'